const USD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

/** `amount_cents` as whole dollars: 31000000 → "$310,000". */
export function formatCents(cents: number): string {
  return USD.format(cents / 100);
}
